import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback, useEffect } from 'react';
import { getDefaultFieldStates, getUnchangedDefaultFieldStates, getWasFormChanged, getHasFormErrors, getAugmentedFieldStates } from './lib';
function useForm(_ref) {
  var fields = _ref.fields,
    createFieldsForEachId = _ref.createFieldsForEachId;
  var _useState = useState(function () {
      return getDefaultFieldStates(fields, createFieldsForEachId);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    fieldStates = _useState2[0],
    setFieldStates = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    scheduledReset = _useState4[0],
    setScheduledReset = _useState4[1];
  var reset = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      keepUserValues = _ref2.keepUserValues;
    return setScheduledReset(keepUserValues ? 'KEEP_CHANGES' : 'DISCARD_ALL');
  }, []);
  useEffect(function () {
    if (scheduledReset) {
      if (scheduledReset === 'DISCARD_ALL') {
        setFieldStates(getDefaultFieldStates(fields));
      } else {
        setFieldStates(function (prevFieldStates) {
          return getUnchangedDefaultFieldStates(fields, createFieldsForEachId, prevFieldStates);
        });
      }
      setScheduledReset(null);
    }
  }, [fields, createFieldsForEachId, scheduledReset]);
  var augmentedFieldStates = getAugmentedFieldStates(fields, createFieldsForEachId, fieldStates, setFieldStates);
  var hasErrors = getHasFormErrors(fields, createFieldsForEachId, augmentedFieldStates);
  var wasChanged = getWasFormChanged(fields, createFieldsForEachId, augmentedFieldStates);
  return {
    fields: augmentedFieldStates,
    reset: reset,
    hasErrors: hasErrors,
    isValid: !hasErrors,
    wasChanged: wasChanged
  };
}
export default useForm;